module.exports = __webpack_public_path__ + "static/media/filtro-soft.c5e4a759.webp";